(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panna-wardrobe-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var pnwrInstances = new WeakMap();
  var pnwrLocks = new Set();
  var pnwrBodyOverflow = '';
  var pnwrBodyPriority = '';
  var pnwrRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function pnwrLock(pnwrDialog) {
    if (!pnwrLocks.size) {
      pnwrBodyOverflow = document.body.style.getPropertyValue('overflow');
      pnwrBodyPriority = document.body.style.getPropertyPriority('overflow');
      document.body.style.setProperty('overflow', 'hidden');
    }
    pnwrLocks.add(pnwrDialog);
  }
  function pnwrUnlock(pnwrDialog) {
    if (!pnwrLocks.delete(pnwrDialog) || pnwrLocks.size) return;
    if (pnwrBodyOverflow) document.body.style.setProperty('overflow', pnwrBodyOverflow, pnwrBodyPriority);
    else document.body.style.removeProperty('overflow');
  }
  /* Strip money wrappers without inserting their HTML into the live document. */
  function pnwrPlainMoney(pnwrValue) {
    var pnwrText = String(pnwrValue || '');
    for (var pnwrPass = 0; pnwrPass < 3; pnwrPass++) {
      var pnwrNext = new DOMParser().parseFromString(pnwrText, 'text/html').body.textContent || '';
      if (pnwrNext === pnwrText) break;
      pnwrText = pnwrNext;
    }
    return pnwrText.trim();
  }
  function pnwrInit(pnwrRoot) {
    if (pnwrInstances.has(pnwrRoot)) return;
    var pnwrDialog = pnwrRoot.querySelector('[data-pnwr-dialog]');
    var pnwrGallery = pnwrRoot.querySelector('.pnwr-gallery');
    if (!pnwrDialog || !pnwrGallery || !pnwrDialog.showModal) return;
    var pnwrItems = Array.from(pnwrGallery.querySelectorAll('[data-pnwr-item]'));
    if (!pnwrItems.length) return;
    var pnwrStyles = getComputedStyle(pnwrRoot);
    /* Copy inherited body font before the dialog leaves the theme container. */
    pnwrDialog.style.cssText = pnwrRoot.getAttribute('style') || '';
    pnwrDialog.style.fontFamily = pnwrStyles.fontFamily;
    pnwrDialog.style.setProperty('--pnwr-font-head', pnwrStyles.getPropertyValue('--pnwr-font-head').trim() || pnwrStyles.fontFamily);
    document.body.appendChild(pnwrDialog);
    function pnwrFind(pnwrName) { return pnwrDialog.querySelector('[data-pnwr-' + pnwrName + ']'); }
    function pnwrLabel(pnwrName) { return pnwrRoot.getAttribute('data-pnwr-' + pnwrName) || ''; }
    var pnwrMain = pnwrFind('main'), pnwrTitle = pnwrFind('title'), pnwrPrice = pnwrFind('price');
    var pnwrCompare = pnwrFind('compare'), pnwrSaving = pnwrFind('saving'), pnwrAvailability = pnwrFind('availability');
    var pnwrSelect = pnwrFind('select'), pnwrOptionWrap = pnwrFind('option-wrap'), pnwrQty = pnwrFind('quantity');
    var pnwrAtc = pnwrFind('add'), pnwrDetails = pnwrFind('details'), pnwrMsg = pnwrFind('message');
    var pnwrThumbs = pnwrFind('thumbs'), pnwrZoom = pnwrFind('zoom'), pnwrImageWrap = pnwrFind('image-wrap');
    var pnwrDesc = pnwrFind('desc'), pnwrCloseButton = pnwrFind('close');
    var pnwrSelected = -1, pnwrVersion = 0, pnwrBusy = false, pnwrAlive = true;
    var pnwrSaved = new Map(), pnwrListeners = [], pnwrCloseTimer = 0, pnwrIntroTimer = 0, pnwrRaf = 0;
    var pnwrReturnFocus = null, pnwrResize = null, pnwrIntersection = null, pnwrBackdropDown = false;
    var pnwrMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pnwrUseAtc = pnwrLabel('atc') === 'true';
    var pnwrCart = pnwrLabel('cart') || pnwrRoute + 'cart';
    function pnwrListen(pnwrTarget, pnwrType, pnwrHandler, pnwrOptions) {
      pnwrTarget.addEventListener(pnwrType, pnwrHandler, pnwrOptions);
      pnwrListeners.push(function () { pnwrTarget.removeEventListener(pnwrType, pnwrHandler, pnwrOptions); });
    }
    function pnwrClear() { pnwrMsg.textContent = ''; pnwrMsg.classList.remove('pnwr-error'); }
    function pnwrQuantity() {
      var pnwrValue = Number(pnwrQty.value);
      pnwrValue = Number.isFinite(pnwrValue) ? Math.round(pnwrValue) : 1;
      pnwrQty.value = Math.max(1, Math.min(99, pnwrValue));
      return Number(pnwrQty.value);
    }
    function pnwrImage(pnwrButton, pnwrAnimate) {
      if (!pnwrButton) return;
      pnwrMain.src = pnwrButton.dataset.src;
      pnwrMain.alt = pnwrButton.dataset.alt || pnwrTitle.textContent;
      pnwrThumbs.querySelectorAll('[data-pnwr-image]').forEach(function (pnwrThumb) {
        pnwrThumb.setAttribute('aria-pressed', String(pnwrThumb === pnwrButton));
      });
      pnwrImageWrap.classList.remove('pnwr-zoomed');
      pnwrZoom.setAttribute('aria-pressed', 'false');
      if (pnwrAnimate && !pnwrMotion.matches && pnwrMain.animate) {
        pnwrMain.getAnimations().forEach(function (pnwrAnimation) { pnwrAnimation.cancel(); });
        pnwrMain.animate([{ opacity: .4 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
      }
    }
    function pnwrBuyState(pnwrChangeImage) {
      var pnwrOption = pnwrSelect.selectedOptions[0];
      var pnwrSold = !pnwrOption || pnwrOption.dataset.available !== 'true';
      pnwrPrice.textContent = pnwrOption ? pnwrPlainMoney(pnwrOption.dataset.price) : '';
      var pnwrCompareText = pnwrOption ? pnwrPlainMoney(pnwrOption.dataset.compare) : '';
      pnwrCompare.textContent = pnwrCompareText;
      pnwrCompare.hidden = !pnwrCompareText;
      var pnwrCurrent = pnwrOption ? Number(pnwrOption.dataset.priceCents) : 0;
      var pnwrOriginal = pnwrOption ? Number(pnwrOption.dataset.compareCents) : 0;
      var pnwrPercent = pnwrOriginal > pnwrCurrent && pnwrOriginal > 0 ? Math.round((pnwrOriginal - pnwrCurrent) * 100 / pnwrOriginal) : 0;
      pnwrSaving.hidden = !pnwrPercent;
      pnwrSaving.textContent = pnwrPercent ? pnwrPercent + '% OFF' : '';
      pnwrAvailability.textContent = pnwrSold ? pnwrLabel('sold') : 'Available';
      pnwrAtc.disabled = pnwrBusy || pnwrSold;
      pnwrAtc.setAttribute('aria-busy', String(pnwrBusy));
      pnwrAtc.textContent = pnwrSold ? pnwrLabel('sold') : pnwrBusy ? pnwrLabel('adding') : pnwrLabel('atc-label') + '  →';
      if (pnwrChangeImage && pnwrOption && pnwrOption.dataset.imageId) {
        var pnwrMatching = Array.from(pnwrThumbs.children).find(function (pnwrThumb) { return pnwrThumb.dataset.imageId === pnwrOption.dataset.imageId; });
        if (pnwrMatching) pnwrImage(pnwrMatching, true);
      }
    }
    function pnwrRemember() {
      if (pnwrSelected >= 0) pnwrSaved.set(pnwrSelected, { variant: pnwrSelect.value, quantity: pnwrQuantity() });
    }
    function pnwrOpen(pnwrIndex) {
      pnwrRemember();
      pnwrSelected = (pnwrIndex + pnwrItems.length) % pnwrItems.length;
      pnwrVersion++;
      var pnwrSource = pnwrItems[pnwrSelected].querySelector('[data-pnwr-product]').content;
      var pnwrData = pnwrSource.querySelector('[data-pnwr-data]');
      var pnwrSourceSelect = pnwrSource.querySelector('[data-pnwr-variants]');
      pnwrTitle.textContent = pnwrData.dataset.title;
      pnwrDetails.href = pnwrData.dataset.url;
      pnwrDesc.textContent = pnwrSource.querySelector('[data-pnwr-description]').textContent;
      pnwrDesc.hidden = !pnwrDesc.textContent.trim();
      pnwrSelect.replaceChildren();
      Array.from(pnwrSourceSelect.options).forEach(function (pnwrOption) { pnwrSelect.appendChild(pnwrOption.cloneNode(true)); });
      var pnwrMemory = pnwrSaved.get(pnwrSelected);
      pnwrSelect.selectedIndex = pnwrSourceSelect.selectedIndex;
      if (pnwrMemory) pnwrSelect.value = pnwrMemory.variant;
      if (pnwrSelect.selectedIndex < 0) pnwrSelect.selectedIndex = 0;
      pnwrOptionWrap.hidden = pnwrSelect.options.length === 1 && pnwrSelect.options[0].dataset.default === 'true';
      pnwrQty.value = pnwrMemory ? pnwrMemory.quantity : 1;
      pnwrThumbs.replaceChildren();
      pnwrSource.querySelectorAll('[data-pnwr-image]').forEach(function (pnwrButton) {
        var pnwrClone = pnwrButton.cloneNode(true);
        var pnwrThumb = document.createElement('img');
        pnwrThumb.src = pnwrClone.dataset.thumb;
        pnwrThumb.alt = '';
        pnwrThumb.width = 80; pnwrThumb.height = 100;
        pnwrThumb.loading = 'lazy';
        pnwrClone.appendChild(pnwrThumb);
        pnwrThumbs.appendChild(pnwrClone);
      });
      pnwrThumbs.hidden = pnwrThumbs.children.length < 2;
      pnwrThumbs.scrollTop = 0; pnwrThumbs.scrollLeft = 0;
      pnwrImage(pnwrThumbs.firstElementChild, false);
      pnwrBuyState(true);
      pnwrClear();
      pnwrFind('counter').textContent = String(pnwrSelected + 1).padStart(2, '0') + ' / ' + String(pnwrItems.length).padStart(2, '0');
      pnwrFind('prev').hidden = pnwrItems.length < 2;
      pnwrFind('next').hidden = pnwrItems.length < 2;
      clearTimeout(pnwrCloseTimer);
      pnwrDialog.classList.remove('pnwr-closing');
      if (!pnwrDialog.open) {
        pnwrReturnFocus = pnwrItems[pnwrSelected].querySelector('[data-pnwr-open]');
        pnwrDialog.showModal();
        pnwrLock(pnwrDialog);
        pnwrCloseButton.focus({ preventScroll: true });
      } else if (!pnwrMotion.matches && pnwrFind('content').animate) {
        pnwrFind('content').getAnimations().forEach(function (pnwrAnimation) { pnwrAnimation.cancel(); });
        pnwrFind('content').animate([{ opacity: .35, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 300, easing: 'ease-out' });
      }
      pnwrDialog.scrollTop = 0;
    }
    function pnwrFinishClose() {
      if (pnwrDialog.open) pnwrDialog.close();
      pnwrUnlock(pnwrDialog);
      pnwrDialog.classList.remove('pnwr-closing');
    }
    function pnwrClose() {
      if (!pnwrDialog.open || pnwrDialog.classList.contains('pnwr-closing')) return;
      pnwrRemember(); pnwrVersion++;
      if (pnwrMotion.matches) { pnwrFinishClose(); return; }
      pnwrDialog.classList.add('pnwr-closing');
      pnwrCloseTimer = setTimeout(pnwrFinishClose, 180);
    }
    pnwrAtc.hidden = !pnwrUseAtc;
    pnwrFind('quantity-wrap').hidden = !pnwrUseAtc;
    pnwrItems.forEach(function (pnwrItem, pnwrIndex) {
      pnwrListen(pnwrItem.querySelector('[data-pnwr-open]'), 'click', function (pnwrEvent) {
        if (pnwrEvent.metaKey || pnwrEvent.ctrlKey || pnwrEvent.shiftKey || pnwrEvent.altKey || pnwrEvent.button > 0) return;
        pnwrEvent.preventDefault(); pnwrOpen(pnwrIndex);
      });
    });
    pnwrListen(pnwrCloseButton, 'click', pnwrClose);
    pnwrListen(pnwrDialog, 'cancel', function (pnwrEvent) { pnwrEvent.preventDefault(); pnwrClose(); });
    pnwrListen(pnwrDialog, 'close', function () {
      clearTimeout(pnwrCloseTimer); pnwrUnlock(pnwrDialog); pnwrDialog.classList.remove('pnwr-closing');
      pnwrVersion++;
      if (pnwrAlive && pnwrReturnFocus && pnwrReturnFocus.isConnected) pnwrReturnFocus.focus({ preventScroll: true });
    });
    function pnwrOutside(pnwrEvent) {
      var pnwrRect = pnwrDialog.getBoundingClientRect();
      return pnwrEvent.target === pnwrDialog && (pnwrEvent.clientX < pnwrRect.left || pnwrEvent.clientX > pnwrRect.right || pnwrEvent.clientY < pnwrRect.top || pnwrEvent.clientY > pnwrRect.bottom);
    }
    pnwrListen(pnwrDialog, 'pointerdown', function (pnwrEvent) { pnwrBackdropDown = pnwrOutside(pnwrEvent); });
    pnwrListen(pnwrDialog, 'click', function (pnwrEvent) { if (pnwrBackdropDown && pnwrOutside(pnwrEvent)) pnwrClose(); pnwrBackdropDown = false; });
    pnwrListen(pnwrFind('prev'), 'click', function () { pnwrOpen(pnwrSelected - 1); });
    pnwrListen(pnwrFind('next'), 'click', function () { pnwrOpen(pnwrSelected + 1); });
    pnwrListen(pnwrDialog, 'keydown', function (pnwrEvent) {
      if (pnwrEvent.target.closest('input,select,textarea,button,[contenteditable="true"]')) return;
      if (pnwrEvent.key === 'ArrowLeft') { pnwrEvent.preventDefault(); pnwrOpen(pnwrSelected - 1); }
      if (pnwrEvent.key === 'ArrowRight') { pnwrEvent.preventDefault(); pnwrOpen(pnwrSelected + 1); }
    });
    pnwrListen(pnwrSelect, 'change', function () { pnwrVersion++; pnwrClear(); pnwrBuyState(true); pnwrRemember(); });
    pnwrListen(pnwrQty, 'change', pnwrRemember);
    pnwrListen(pnwrFind('qty-minus'), 'click', function () { pnwrQty.value = Math.max(1, pnwrQuantity() - 1); pnwrRemember(); });
    pnwrListen(pnwrFind('qty-plus'), 'click', function () { pnwrQty.value = Math.min(99, pnwrQuantity() + 1); pnwrRemember(); });
    pnwrListen(pnwrThumbs, 'click', function (pnwrEvent) { var pnwrButton = pnwrEvent.target.closest('[data-pnwr-image]'); if (pnwrButton) pnwrImage(pnwrButton, true); });
    pnwrListen(pnwrZoom, 'click', function () { var pnwrZoomed = pnwrImageWrap.classList.toggle('pnwr-zoomed'); pnwrZoom.setAttribute('aria-pressed', String(pnwrZoomed)); });
    function pnwrCartIcon(pnwrSections) {
      var pnwrCurrent = document.getElementById('cart-icon-bubble');
      if (!pnwrCurrent || !pnwrSections || !pnwrSections['cart-icon-bubble']) return;
      var pnwrParsed = new DOMParser().parseFromString(pnwrSections['cart-icon-bubble'], 'text/html');
      var pnwrIncoming = pnwrParsed.getElementById('cart-icon-bubble') || pnwrParsed.querySelector('.shopify-section');
      if (pnwrIncoming) pnwrCurrent.innerHTML = pnwrIncoming.innerHTML;
    }
    pnwrListen(pnwrAtc, 'click', async function () {
      if (!pnwrUseAtc || pnwrBusy || pnwrAtc.disabled || !pnwrSelect.value) return;
      var pnwrRequestVersion = pnwrVersion;
      var pnwrVariant = pnwrSelect.value;
      var pnwrAmount = pnwrQuantity();
      pnwrBusy = true; pnwrClear(); pnwrBuyState(false);
      function pnwrCurrent() { return pnwrAlive && pnwrDialog.open && pnwrVersion === pnwrRequestVersion; }
      try {
        var pnwrResponse = await fetch(pnwrRoute + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: pnwrVariant, quantity: pnwrAmount }], sections: ['cart-icon-bubble'], sections_url: window.location.pathname })
        });
        var pnwrData = await pnwrResponse.json();
        if (!pnwrResponse.ok || pnwrData.status) throw new Error(pnwrData.description || pnwrData.message || pnwrLabel('error'));
        try {
          pnwrCartIcon(pnwrData.sections);
          document.dispatchEvent(new CustomEvent('pnwr:added', { detail: pnwrData }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pnwr', data: pnwrData } }));
        } catch (pnwrRefreshError) { console.warn('PANNA cart display refresh failed.', pnwrRefreshError); }
        if (!pnwrAlive) return;
        if (pnwrLabel('after') === 'redirect') { window.location.assign(pnwrCart); return; }
        if (pnwrCurrent()) {
          pnwrMsg.textContent = '✓ ' + pnwrLabel('added') + '. ';
          var pnwrLink = document.createElement('a'); pnwrLink.href = pnwrCart; pnwrLink.textContent = pnwrLabel('cart-label'); pnwrMsg.appendChild(pnwrLink);
        }
      } catch (pnwrError) {
        if (pnwrCurrent()) { pnwrMsg.textContent = pnwrError.message || pnwrLabel('error'); pnwrMsg.classList.add('pnwr-error'); }
      } finally { pnwrBusy = false; if (pnwrAlive) pnwrBuyState(false); }
    });
    var pnwrControls = pnwrRoot.querySelector('.pnwr-gallery-controls');
    function pnwrGalleryState() {
      if (!pnwrAlive) return;
      var pnwrOverflow = pnwrGallery.scrollWidth > pnwrGallery.clientWidth + 2;
      pnwrGallery.classList.toggle('pnwr-centered', !pnwrOverflow);
      if (pnwrControls) {
        pnwrControls.hidden = !pnwrOverflow;
        var pnwrButtons = pnwrControls.querySelectorAll('[data-pnwr-scroll]');
        pnwrButtons[0].disabled = pnwrGallery.scrollLeft <= 2;
        pnwrButtons[1].disabled = pnwrGallery.scrollLeft >= pnwrGallery.scrollWidth - pnwrGallery.clientWidth - 2;
      }
    }
    function pnwrSchedule() { cancelAnimationFrame(pnwrRaf); pnwrRaf = requestAnimationFrame(pnwrGalleryState); }
    pnwrRoot.querySelectorAll('[data-pnwr-scroll]').forEach(function (pnwrButton) {
      pnwrListen(pnwrButton, 'click', function () { pnwrGallery.scrollBy({ left: Number(pnwrButton.dataset.pnwrScroll) * pnwrGallery.clientWidth * .75, behavior: pnwrMotion.matches ? 'auto' : 'smooth' }); });
    });
    pnwrListen(pnwrGallery, 'scroll', pnwrSchedule, { passive: true });
    pnwrListen(window, 'resize', pnwrSchedule);
    if ('ResizeObserver' in window) { pnwrResize = new ResizeObserver(pnwrSchedule); pnwrResize.observe(pnwrGallery); }
    pnwrSchedule();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (pnwrAlive) pnwrSchedule(); });
    function pnwrReveal() {
      if (pnwrIntersection) pnwrIntersection.disconnect();
      pnwrRoot.classList.remove('pnwr-wait'); pnwrRoot.classList.add('pnwr-enter');
      clearTimeout(pnwrIntroTimer); pnwrIntroTimer = setTimeout(function () { pnwrRoot.classList.remove('pnwr-enter'); }, 2000);
    }
    if ('IntersectionObserver' in window && !pnwrMotion.matches) {
      pnwrRoot.classList.add('pnwr-wait');
      pnwrIntersection = new IntersectionObserver(function (pnwrEntries) { if (pnwrEntries.some(function (pnwrEntry) { return pnwrEntry.isIntersecting; })) pnwrReveal(); }, { threshold: .05 });
      pnwrIntersection.observe(pnwrGallery);
    }
    if (pnwrMotion.addEventListener) pnwrListen(pnwrMotion, 'change', function () {
      if (!pnwrMotion.matches) return;
      pnwrReveal();
      pnwrDialog.querySelectorAll('*').forEach(function (pnwrElement) { if (pnwrElement.getAnimations) pnwrElement.getAnimations().forEach(function (pnwrAnimation) { pnwrAnimation.cancel(); }); });
      if (pnwrDialog.classList.contains('pnwr-closing')) { clearTimeout(pnwrCloseTimer); pnwrFinishClose(); }
    });
    pnwrInstances.set(pnwrRoot, function () {
      pnwrAlive = false; pnwrVersion++; clearTimeout(pnwrCloseTimer); clearTimeout(pnwrIntroTimer); cancelAnimationFrame(pnwrRaf);
      if (pnwrResize) pnwrResize.disconnect(); if (pnwrIntersection) pnwrIntersection.disconnect();
      pnwrListeners.forEach(function (pnwrRemove) { pnwrRemove(); });
      if (pnwrDialog.open) pnwrDialog.close(); pnwrUnlock(pnwrDialog); pnwrDialog.remove();
      pnwrRoot.classList.remove('pnwr-wait', 'pnwr-enter'); pnwrInstances.delete(pnwrRoot);
    });
  }
  function pnwrRoots(pnwrScope) {
    var pnwrResult = pnwrScope.matches && pnwrScope.matches('[data-pnwr]') ? [pnwrScope] : [];
    return pnwrResult.concat(Array.from(pnwrScope.querySelectorAll('[data-pnwr]')));
  }
  function pnwrInitAll(pnwrScope) { pnwrRoots(pnwrScope || document).forEach(pnwrInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pnwrInitAll(document); }, { once: true });
  else pnwrInitAll(document);
  document.addEventListener('shopify:section:load', function (pnwrEvent) { pnwrInitAll(pnwrEvent.target); });
  document.addEventListener('shopify:section:unload', function (pnwrEvent) { pnwrRoots(pnwrEvent.target).forEach(function (pnwrRoot) { var pnwrDestroy = pnwrInstances.get(pnwrRoot); if (pnwrDestroy) pnwrDestroy(); }); });
})();

  } catch(e) { console.error(e); }
})();
})();
